<template>


  <v-container fill-width fill-height class="d-flex align-start">
    <v-row style="padding-top: 50px;">  
      <v-col class="pb-10" cols="12" justify="center" align="center">
        <h3 class="text-center align-self-center"> Erro ao carregar componente </h3>
      </v-col>
      <v-col class="py-0" cols="12" justify="center" align="center">
        <v-icon x-large color="error"> mdi-cloud-question </v-icon>  
      </v-col>
      <v-col cols="12" class="py-0">    
        <h4 class="text-center align-self-center"> Você ainda está conectado na internet? </h4>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
    name: 'TimeOut',
    data () {
      return {

      }
    }
  
}
</script>

<style>

  .home {
    align-self: center!important;
  }

</style>


// WEBPACK FOOTER //
// src/views/Comum/_timeout.vue